import { parsed } from "utils/parsed";
import axiosInstance from "utils/request";
import { z } from "zod";
import {
  type LidarMergeOptions,
  LidarMergeOptionsSchema,
  type ProjectLidarUploadStatus,
  ProjectLidarUploadStatusSchema,
} from "./schemas";

export function fetchLidarUploadStatus(
  projectReferences: string[],
  refresh = false
): Promise<ProjectLidarUploadStatus[]> {
  return parsed(
    z.array(ProjectLidarUploadStatusSchema),
    axiosInstance.get("/lidar_upload/status", {
      params: { projects: projectReferences.join(","), refresh },
    })
  );
}

export function fetchMergeOptions(
  region: string,
  projectId: number
): Promise<LidarMergeOptions> {
  return parsed(
    LidarMergeOptionsSchema,
    axiosInstance.get(`/lidar_upload/${region}/${projectId}/merge_options`)
  );
}

export async function triggerMerge(
  region: string,
  projectId: number,
  clearanceSystemId: number,
  cfgTemplateId: number
): Promise<void> {
  await axiosInstance.post(`/lidar_upload/${region}/${projectId}/merge`, {
    run_analysis: true,
    clearance_system_id: clearanceSystemId,
    cfg_template_id: cfgTemplateId,
  });
}
